import React from 'react';
import { compose } from 'lodash/fp';
import {
  connectStateResults,
  connectInfiniteHits,
} from 'react-instantsearch/connectors';
import { ChevronDown } from 'react-feather';
import { Icon } from 'ui';

const ShowMoreButton = ({
  hasMore,
  hits,
  refineNext,
  searchResults,
  featherIcon = false,
}) => {
  if (!hasMore) {
    return false;
  }
  const { hitsPerPage } = searchResults;
  const remainingHits = searchResults.nbHits - hits.length;
  const nbHitsToAdd = Math.min(remainingHits, hitsPerPage);
  return (
    <button
      type="button"
      className="u-linkBtn mt-16 fz-bigger d-f ai-c"
      onClick={refineNext}
      onMouseDown={e => {
        // Prevents mouse click focus ring
        e.preventDefault();
      }}
    >
      {t('learning_library.search.show_more_matches', { count: nbHitsToAdd })}
      {featherIcon ? (
        <ChevronDown className="u-linkBtn ml-4" size={20} />
      ) : (
        <Icon name="caret_down" className="ml-4 fz-base" />
      )}
    </button>
  );
};

export default compose(
  connectInfiniteHits,
  connectStateResults,
)(ShowMoreButton);
